//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import menuList from '~/config/navigationUsers';

export default {
  data() {
    return {
      menuList,
      selectedItem: 0,
    };
  },

  methods: {
    isCurrentRoute(name) {
      const currentRouteName = this.$route.name;
      return (name === currentRouteName);
    },
  },
};
